import ThemeNavigationCard from '../navigation/ThemeNavigationCard'
import { themeAtom } from '@/features/app-layout/atoms/theme-atoms'
import { useAtomValue } from 'jotai'
import {  CopyPlus, Rss } from 'lucide-react'
import { ChatMessageType } from '../../types'

type Props = {
  setStep: (id: ChatMessageType) => void,
  setStatus: (id: number) => void,
}

const ThemeEmptyState = ({ setStep, setStatus }: Props) => {

  const appTheme = useAtomValue(themeAtom)


  return (
    <div className='w-full flex flex-col items-center gap-2 pt-5'>
      <p className='font-montserrat text-2xl md:text-4xl font-semibold text-amber-500'>There are no campaigns yet 🫨</p>
      <p className='text-lg font-poppins font-medium tracking-wide text-gray-500'>Hop in to create a social media campaign</p>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-3 pt-4">
        <ThemeNavigationCard name="siAi Theme Ideas" description="Suggested themes from siAi" emoji="📅" onNavigate={() => {
          setStatus(1)
          setStep("first")
        }} icon={Rss} />
        <ThemeNavigationCard name="Make Your Own Post" description={`Create customized theme ${!appTheme.isClient ? "( currently disabled )" : ""}`} emoji="🧩" onNavigate={() => {
          setStep("create-post")
        }} icon={CopyPlus} />
      </div>
    </div>
  )
}

export default ThemeEmptyState;
